import { createSelector } from '@ngrx/store';
import { selectFeatureStore } from './generic.selectors';

export const selectComplianceSummary = createSelector(
  selectFeatureStore,
  ({ complianceSummary }) => complianceSummary,
);
